/**
 * Default t-shirt sizes for dialog
 * sm - Small, 400px width (25rem)
 * md - Medium, 600px width (37.5rem)
 * lg - Large, 800px width (50rem)
 * xl - Extra large, 1000px width (62.5rem)
 */
let DialogSizes = /*#__PURE__*/function (DialogSizes) {
  DialogSizes["sm"] = "400px";
  DialogSizes["md"] = "600px";
  DialogSizes["lg"] = "800px";
  DialogSizes["xl"] = "1000px";
  return DialogSizes;
}({});
const dialogSizes = {
  ...DialogSizes
};

/**
 * Dialog type
 */
let DialogTypes = /*#__PURE__*/function (DialogTypes) {
  DialogTypes["alertdialog"] = "alertdialog";
  DialogTypes["dialog"] = "dialog";
  return DialogTypes;
}({});
const dialogTypes = {
  ...DialogTypes
};

export { DialogSizes, DialogTypes, dialogSizes, dialogTypes };
